
import css from 'styled-jsx/css';

export default css`.customer-story-card {
  width: 100%;

  &__image-container {
    position: relative;

    &::before {
      content: '';
      display: block;
      padding-top: calc(2 / 3 * 100%);
    }
  }

  &__image {
    border-radius: 24px;
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__logo-container {
    background-color: $slate;
    border-radius: 16px;
    bottom: 0.5rem;
    left: 0.5rem;
    height: 3.75rem;
    padding: 0.125rem 1.25rem;
    position: absolute;
    display: block;
  }

  &__logo {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    width: auto;
  }

  &__content {
    padding: 1.75rem 0.5rem 0;
  }

  &__title {
    margin-bottom: 1.5rem;
  }

  &__snapshot-cta {
    border-bottom: 1px dashed $slate;
    display: block;
    margin-bottom: 1.5rem;
    width: fit-content;

    &:hover {
      border-bottom-color: transparent;
      cursor: pointer;
    }
  }

  &__cta {
    display: inline-block;
    text-align: left;
  }
}

.customer-story-card--featured {
  .customer-story-card__image-container {
    &::before {
      padding-top: 100%;
    }
  }

  .customer-story-card__image {
    object-position: right;
  }

  @include media-query(tablet) {
    position: relative;

    .customer-story-card__content {
      display: grid;
      grid-column-gap: 20px;
      grid-template-columns: repeat(8, 1fr);
      left: 0;
      margin-top: 22px;
      padding: 0 0 0 1.75rem;
      position: absolute;
      top: 0px;

      > * {
        grid-column-start: 1;
        grid-column-end: 5;
      }
    }

    .customer-story-card__image-container {
      &::before {
        padding-top: calc(2 / 3 * 100%);
      }
    }

    .customer-story-card__image {
      object-position: 50% 50%;
    }
  }
}

.customer-story-card__modal {
  &__close-button {
    cursor: pointer;
    position: absolute;
    top: 1.125rem;
    right: 1.125rem;
    height: 1rem;
    width: 1rem;
    z-index: 1;

    svg {
      height: 1rem;
      width: 1rem;
    }
  }

  &__logo-container {
    align-items: center;
    background-color: $white;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    padding: 2.25rem 0;
  }

  &__sidebar {
    background-color: $stone;
    padding: 2.375rem 0 1.0625rem;
  }

  @include media-query(tablet) {
    display: grid;
    grid-template-columns: [sidebar] 4fr [main-left-gutter] 1fr [main] 6fr [main-right-gutter] 1fr;
    grid-column-gap: 20px;

    &__main {
      grid-column: main;
      padding: 2.375rem 0 3.125rem;
    }

    &__sidebar {
      grid-column: sidebar;
      padding: 2.9375rem 3rem;
    }
  }

  @include media-query(mobile) {
    &__main,
    &__sidebar {
      display: grid;
      grid-template-columns: [left-gutter] 1fr [content] 9fr [right-gutter] 1fr;
      grid-column-gap: 6px;
    }

    &__title,
    &__body,
    &__cta,
    &__logo-container,
    &__sidebar__body {
      grid-column: content;
    }
  }

  &__sidebar__body {
    margin-top: 25px;
  }

  &__logo {
    max-height: 4rem;
    max-width: 100%;
    width: auto;
  }

  &__main {
    padding: 2.125rem 0 3.3125rem;
  }

  &__body {
    margin-top: 1rem;
  }

  &__cta {
    margin-top: 2.5rem;
  }

  &__sidebar__body,
  &__body {
    :global(.rich-text) {
      :global(h6) {
        font-size: 1.125rem;
        font-family: $fontTTNormsPro;
        line-height: 132%;
        font-weight: bold;
        margin-bottom: 1.25rem;

        @include media-query(tablet) {
          font-weight: 800;
          letter-spacing: 0.01em;
        }
      }

      :global(ul) {
        :global(li) {
          margin-bottom: 0;

          :global(p) {
            padding-left: 0;
            margin-bottom: 0;
          }

          :global(p::before) {
            content: none;
            display: none;
          }
        }
      }
    }
  }
}
`